export const TAB_SCROLL_BUTTON_HIDE_DELAY = 300
